import React from 'react';
import moment from 'moment';
import {
    EAnnex6V2RecordState,
    TAnnex6V2Record,
} from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupM2 } from '../../../../../../../redux/app/annex6-v2/groups/group-m';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';
import Annex6V2Previewer from '../../../history/Annex6V2Previewer';
import { marpolUtils } from '../../../../../../../redux/app/marpol';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupM2PreviewProps = OwnProps;

function Annex6V2GroupM2Preview(props: Annex6V2GroupM2PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupM2;
    const operationDate = moment(
        record.itemM2P1.dateOfOriginalOperation,
        'YYYY-MM-DD'
    ).format('DD-MMM-YYYY');

    function renderMain() {
        const tableRows = [[operationDate, 'M', '-', renderItemM2P1()]];

        return (
            <>
                <Annex6V2TableRows
                    record={record}
                    tableRows={tableRows}
                    theme={props.theme}
                />
                {renderMissedEntry()}
            </>
        );
    }

    function renderItemM2P1() {
        return (
            <h4 className="font-medium uppercase">
                {record.entry === 'incorrect'
                    ? 'ENTRY PERTAINING TO AN EARLY INCORRECT OPERATIONAL ENTRY'
                    : 'ENTRY PERTAINING TO AN EARLIER MISSED OPERATIONAL ENTRY'}
                {record.itemM2P1.receiptAttachment &&
                    record.itemM2P1.receiptAttachment !== ' ' && (
                        <>
                            <br />
                            CORRECTION NOTE:{' '}
                            <a
                                href={marpolUtils.getAttachmentURL(
                                    record.itemM2P1.receiptAttachment,
                                    record.id,
                                    record._rev
                                )}
                                download={record.itemM2P1.receiptAttachment}
                            >
                                {record.itemM2P1.receiptAttachment}
                            </a>
                        </>
                    )}
            </h4>
        );
    }

    function renderMissedEntry() {
        if (!record.itemM2P1.isAnMissedEntryRecord) {
            return null;
        }

        if (!record.itemM2P1.missedRecord) {
            return (
                <div className="flex flex-row items-center justify-center p-6 px-12 font-medium text-center bg-gray-100 border-2 border-gray-400 border-dashed">
                    <div>MISSED ENTRY WILL APPEAR HERE</div>
                    <span className="ml-6 text-gray-400 bp3-icon bp3-icon-time"></span>
                </div>
            );
        }

        return (
            <Annex6V2Previewer
                annex6V2Record={{
                    ...record.itemM2P1.missedRecord,
                    selectedDate: record.selectedDate,
                    state: props.isStrikedOff
                        ? EAnnex6V2RecordState.STRIKED_OFF
                        : record.itemM2P1.missedRecord.state,
                }}
            />
        );
    }

    return renderMain();
}

export default Annex6V2GroupM2Preview;
